<template>
    <div class="cond-bars">
        <div v-for="bar in bars" :key="bar.label" class="cond-bar"
            :style="{ flexGrow: bar.pct, background: bar.bg, borderColor: bar.border, color: bar.color }"
            @click="$emit('select', bar)">
            <span class="cond-pct">{{ bar.pct }}%</span>
            <div class="cond-info">
                <span class="cond-lbl">{{ bar.label }}</span>
                <span class="cond-count">{{ $tc('statistics.injuries_count', bar.count, { count: bar.count }) }}</span>
            </div>
        </div>
        <div v-if="bars.length" class="cond-total">
            {{ $tc('statistics.total_injuries_count', total, { count: total }) }}
        </div>
        <div v-if="!bars.length" class="cond-empty">{{ $t('common.without_data') }}</div>
    </div>
</template>

<script>
import { injurySeverity } from '@/utils/Injuries'

export default {
    name: "InjuryComplexityChart",
    props: {
        docs: {
            type: Array,
            default: null,
        }
    },
    computed: {
        total(vm = this) {
            return vm.docs.filter(doc => doc.complexity).length
        },
        bars(vm = this) {
            const docs = vm.docs.filter(doc => doc.complexity)
            const total = docs.length || 1
            const groups = {}

            docs.forEach(doc => {
                const label = vm.injuryComplexityLabel(doc.complexity)
                if (!groups[label]) groups[label] = { items: [], severity: injurySeverity(doc.complexity) }
                groups[label].items.push(doc)
            })

            return Object.entries(groups)
                .map(([label, { items, severity }]) => ({
                    label,
                    items,
                    count: items.length,
                    pct: parseFloat((items.length / total * 100).toFixed(1)),
                    rank: severity.rank,
                    color: severity.color,
                    bg: severity.bg,
                    border: severity.border,
                }))
                .sort((a, b) => a.rank - b.rank)
        },
    },
}
</script>

<style scoped>
.cond-bars {
    display: flex;
    flex-direction: column;
    gap: 6px;
    height: 100%;
    min-height: 0;
}

.cond-bar {
    flex-basis: 0;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    border: 1px solid;
    border-radius: 9px;
    cursor: pointer;
    transition: filter 0.15s;
}

.cond-bar:hover {
    filter: brightness(1.15);
}

.cond-pct {
    font-size: 20px;
    font-weight: 800;
}

.cond-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1px;
    line-height: 1.2;
}

.cond-lbl {
    font-size: 13px;
    font-weight: 600;
    opacity: 0.85;
}

.cond-count {
    font-size: 10px;
    font-weight: 600;
    opacity: 0.55;
}

.cond-total {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 4px;
    border-top: 1px solid var(--v-outline-base);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--v-txtMuted-base);
}

.cond-empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: var(--v-txtMuted-base);
}
</style>
